import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ProductsComponent} from './products/products.component';
import {LocalizeRouterModule} from '@gilsdav/ngx-translate-router';
import {ProductComponent} from './product/product.component';
import {Paths, SemiPath} from '../../../config/config';
import {ProductResolverService} from './product/product-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: ProductsComponent,
    data: {
      page: Paths.Products
    }
  },
  {
    path: SemiPath.Kit,
    loadChildren: () => import('../kit/kit.module').then(r => r.KitModule)
  },
  {
    path: ':slug',
    component: ProductComponent,
    resolve: {
      product: ProductResolverService
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), LocalizeRouterModule.forChild(routes)],
  exports: [RouterModule, LocalizeRouterModule]
})
export class ProductsRoutingModule {
}
